module.exports = __webpack_public_path__ + "static/img/class_7.9afb0c39.jpg";